import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComment } from '../../../../../models/base/base-comment';
import { CommentsService } from '../../../services/comments.service';
import { InViewDirective } from '../../../directives/in-view.directive';
import { UserProfileBadgeComponent } from '../../user-profile-badge/user-profile-badge.component';

@Component({
  selector: 'app-comment-list',
  standalone: true,
  imports: [CommonModule, InViewDirective, UserProfileBadgeComponent],
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss', '../comments-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentListComponent {
  @Input() comments: BaseComment[] = [];
  @Input() visibilityLabel: string = '';

  private commentsService = inject(CommentsService);

  public onCommentScrolledInView(comment: BaseComment): void {
    if (!comment.readDate) {
      this.commentsService.setCommentScrolledIntoView(comment);
    }
  }
}
